import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Form, Row, Col, Container } from "react-bootstrap";
import { useParams, useLocation, useHistory, Link } from "react-router-dom";
import { Label, Button } from "reactstrap";
import { ReimbursementAPIs } from "../MyReimbursementAPI's";
import { UserConsumer } from "../../../UserContext";
import { MonthlyReimbursementFormAPIs } from "./CreateMonthlyReimbursementAPIS";
import { AlertPopups } from "../../../components/AlertPopups";
import FormStatus from "../../../components/FormStatus";
import CustomReactSelect from "../../../components/CustomReactSelect";

const MonthlyReimbursementForm = (props) => {
	let token = null;
	const date = new Date();
	const monthsList = [
		{ value: 1, label: "January" },
		{ value: 2, label: "February" },
		{ value: 3, label: "March" },
		{ value: 4, label: "April" },
		{ value: 5, label: "May" },
		{ value: 6, label: "June" },
		{ value: 7, label: "July" },
		{ value: 8, label: "August" },
		{ value: 9, label: "September" },
		{ value: 10, label: "October" },
		{ value: 11, label: "November" },
		{ value: 12, label: "December" },
	];
	const { id } = useParams();
	const [ticketNumber, setTicketNumber] = useState(null);
	const history = useHistory();
	const { state } = useLocation();
	const reimbursementStatus = state ? state.status : null;
	const location = useLocation();
	const [formStatus, setFormStatus] = useState({ status: "Draft" });
	const [submissionStatus, setSubmissionStatus] = useState(0);
	const [validateMedicalLimit, setValidateMedicalLimit] = useState(false);
	const [validateHealthClubLimit, setValidateHealthClubLimit] =
		useState(false);
	const [validateFuelMobileLimit, setValidateFuelMobileLimit] =
		useState(false);
	const [validateInternetLimit, setValidateInternetLimit] = useState(false);
	const [selectedMonth, setSelectedMonth] = useState(
		monthsList[date.getMonth()]
	);
	const [status, setStatus] = useState(-1);
	const [selectedYear, setSelectedYear] = useState({
		value: date.getFullYear(),
		label: date.getFullYear().toString(),
	});
	const [currentMonth, setCurrentMonth] = useState();
	//date.toLocaleDateString("en-us", { month: "long" })
	const [recordID, setRecordID] = useState("");
	const [yearsList, setYearsList] = useState(null);
	const [currentYear, setCurrentYear] = useState(date.getFullYear());
	const [limitValidation, setLimitValidation] = useState([
		{
			medical: "",
			internet: "",
			fuel: "",
			healthClub: "",
		},
	]);
	const [reimbursementData, setreimbursementData] = useState({
		generalOPD: "",
		Parents: "",
		Dental: "",
		Maternity: "",
		monthlyInternet: 0,
		healthClub: 0,
		others: 0,
		fuel: 0,
		mobile: 0,
		detail: "",
		currMonthBill: 0,
		previousMonth: 0,
		status: "Draft",
		accountsRemarks: "",
		employeeName: "",
		employeeCode: "",
		employeeID: "",
	});

	const {
		generalOPD,
		Parents,
		Dental,
		Maternity,
		monthlyInternet,
		healthClub,
		others,
		fuel,
		mobile,
		detail,
		accountsRemarks,
	} = reimbursementData;

	let medicalSum =
		parseInt(reimbursementData.generalOPD) +
		parseInt(reimbursementData.Parents) +
		parseInt(reimbursementData.Dental) +
		parseInt(reimbursementData.Maternity);
	let internetSum = parseInt(reimbursementData.monthlyInternet);
	let healthClubSum = parseInt(reimbursementData.healthClub);
	let fuelMobileSum = parseInt(reimbursementData.fuel);
	//ADD This Month Amount

	useEffect(() => {
		setSelectedYear({
			value: date.getFullYear(),
			label: date.getFullYear().toString(),
		});
		//years List
		let list = [];
		let previousYear = date.getFullYear() - 1;
		list.unshift({
			value: previousYear,
			label: previousYear.toString(),
		});
		list.unshift(selectedYear);
		setYearsList(list);
	}, []);
	useEffect(() => {
		const currMonth = new Date().getMonth() + 1;
		if (id != 0 && id) {
			axios
				.get(`${ReimbursementAPIs.GetSingleReimbursement}?Id=${id}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					setCurrentMonth(
						monthsList[new Date(data.reimbursementMonth).getMonth()]
							.label
					);
					setCurrentYear(data.reimbursementMonth?.split("-")[0]);
					setreimbursementData({
						generalOPD: data.claimedOPD,
						Parents: data.claimedParents,
						Dental: data.claimedDental,
						Maternity: data.claimedMaternity,
						monthlyInternet: data.internetMonthly,
						healthClub: data.healthClubBill,
						others: data.internetOther,
						fuel: data.carFuelMaintenance,
						mobile: data.mobileBill,
						detail: data.details,
						currMonthBill: data.thisMonth,
						previousMonth: data.previousMonth,
						status: data.submissionStatus,
						accountsRemarks: data.accountsRemarks,
						ticketNumber: data.appID,
						employeeName: data.employeeName,
						employeeCode: data.employeeCode,
						employeeID: data.employeeId,
					});
					setFormStatus({
						status: data.submissionStatus,
						employeeId: data.employeeId,
					});
					let year = new Date(data.reimbursementMonth);
					let month = new Date(data.reimbursementMonth).getMonth();
					setSelectedMonth(monthsList[month]);
					setSelectedYear({
						value: year.getFullYear(),
						label: year.getFullYear().toString(),
					});
					setRecordID(data.appID);
					setTicketNumber(data.appID);
				});
			var month_name = function (dt) {
				let mlist = [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December",
				];
				return mlist[dt.getMonth()];
			};
		} else {
			axios
				.get(
					`${ReimbursementAPIs.GetSingleReimbursement}?Month=${currMonth}&Year=${currentYear}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then(({ data }) => {
					let month = new Date(data.reimbursementMonth).getMonth();
					setCurrentMonth(monthsList[month]);
					setCurrentYear(data.reimbursementMonth?.split("-")[0]);
					setSelectedMonth(monthsList[month]);
					setSelectedYear({
						value: data.reimbursementMonth?.split("-")[0],
						label: data.reimbursementMonth
							?.split("-")[0]
							.toString(),
					});
					setreimbursementData({
						generalOPD: data.claimedOPD,
						Parents: data.claimedParents,
						Dental: data.claimedDental,
						Maternity: data.claimedMaternity,
						monthlyInternet: data.internetMonthly,
						healthClub: data.healthClubBill,
						others: data.internetOther,
						fuel: data.carFuelMaintenance,
						mobile: data.mobileBill,
						detail: data.details,
						currMonthBill: data.thisMonth,
						previousMonth: data.previousMonth,
						status: data.submissionStatus,
						employeeCode: data.employeeCode,
						employeeName: data.employeeName,
					});
					setFormStatus({
						...formStatus,
						status: data.submissionStatus,
						employeeId: data.employeeId,
					});
					setTicketNumber(data.appID);
				});
		}
		checkRemainingLimit();
	}, [location, setFormStatus]);

	const limitCalculation = (data) => {
		return Math.round(data * 0.8);
	};
	const handleChange = (e) => {
		setreimbursementData({
			...reimbursementData,
			[e.target.name]: e.target.value,
		});
		if (medicalSum > limitValidation.medical) {
			setValidateMedicalLimit(true);
		} else if (limitValidation.medical > medicalSum) {
			e.target.name === "medical" && setValidateMedicalLimit(false);
		}
		if (internetSum > limitValidation.internet) {
			e.target.name === "internet" && setValidateInternetLimit(true);
		} else if (internetSum < limitValidation.internet) {
			setValidateInternetLimit(false);
		}
		//
		if (healthClubSum > limitValidation.healthClub) {
			e.target.name === "healthClub" && setValidateHealthClubLimit(true);
		} else if (healthClubSum < limitValidation.healthClub) {
			setValidateHealthClubLimit(false);
		}

		if (fuelMobileSum > limitValidation.fuel) {
			e.target.name === "fuel" && setValidateFuelMobileLimit(true);
		} else if (fuelMobileSum < limitValidation.fuel) {
			setValidateFuelMobileLimit(false);
		} else {
			setValidateMedicalLimit(false);
			setValidateHealthClubLimit(false);
			setValidateFuelMobileLimit(false);
		}
	};
	const handleSubmit = () => {
		if (
			(generalOPD === null ||
				parseInt(generalOPD) === 0 ||
				generalOPD === "") &&
			(Parents === null || parseInt(Parents) === 0 || Parents === "") &&
			(Dental === null || parseInt(Dental) === 0 || Dental === "") &&
			(Maternity === null ||
				parseInt(Maternity) === 0 ||
				Maternity === "") &&
			(monthlyInternet === null ||
				parseInt(monthlyInternet) === 0 ||
				monthlyInternet === "") &&
			(others === null || parseInt(others) === 0 || others === "") &&
			(fuel === null || parseInt(fuel) === 0 || fuel === "") &&
			(mobile === null || parseInt(mobile) === 0 || mobile === "") &&
			(healthClub === null ||
				parseInt(healthClub) === 0 ||
				healthClub === "") &&
			(detail === null || detail === "")
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Enter Form Values",
			});
		} else {
			const updateReimbursement = {
				goPatientAmt:
					generalOPD.length === 0 ? 0 : parseInt(generalOPD),
				parentAmt: Parents.length === 0 ? 0 : parseInt(Parents),
				dentistAmt: Dental.length === 0 ? 0 : parseInt(Dental),
				maternityAmt: Maternity.length === 0 ? 0 : parseInt(Maternity),
				internetMonthly:
					monthlyInternet.length === 0
						? 0
						: parseInt(monthlyInternet),
				internetOther: others.length === 0 ? 0 : parseInt(others),
				carFuel: fuel.length === 0 ? 0 : parseInt(fuel),
				mobileBill: mobile.length === 0 ? 0 : parseInt(mobile),
				healthClubBill:
					healthClub.length === 0 ? 0 : parseInt(healthClub),
				submissionStatus: 1,
				details: detail,
				month: selectedMonth.value,
				year: selectedYear.value,
			};

			if (ticketNumber === 0) {
				//post
				AlertPopups.confirmBox
					.fire({
						text: "Are you sure you want to submit?",
					})
					.then((result) => {
						if (result.value) {
							axios
								.post(
									`${MonthlyReimbursementFormAPIs.CreateMonthlyReimbursement}`,
									updateReimbursement,
									{
										headers: {
											Authorization: `Bearer ${token}`,
										},
									}
								)
								.then(({ data }) => {
									setreimbursementData(data);
									AlertPopups.successAlert.fire({
										text: "Reimbursement Submitted Successfully",
									});
									history.push("/MyReimbursement");
								})
								.catch((err) => {
									if (err.response) {
										AlertPopups.ErrorAlert.fire({
											text: `${err.response.data.message}`,
										});
									}
								});
						}
					});
			} //put
			else {
				ticketNumber
					? AlertPopups.confirmBox
							.fire({
								text: "Are you sure you want to submit?",
							})
							.then((result) => {
								if (result.value) {
									axios
										.put(
											`${ReimbursementAPIs.GetMonthlyReimbursement}/${ticketNumber}`,
											updateReimbursement,
											{
												headers: {
													Authorization: `Bearer ${token}`,
												},
											}
										)
										.then(({ data }) => {
											setreimbursementData(data);
											AlertPopups.successAlert.fire({
												text: "Reimbursement Submitted Successfully",
											});
											history.push("/MyReimbursement");
										})
										.catch((err) => {
											if (err.response) {
												AlertPopups.ErrorAlert.fire({
													text: "Reimbursement Already Submitted",
												});
											}
										});
								}
							})
					: AlertPopups.confirmBox
							.fire({
								text: "Are you sure you want to submit?",
							})
							.then((result) => {
								if (result.value) {
									axios
										.post(
											`${MonthlyReimbursementFormAPIs.CreateMonthlyReimbursement}`,
											updateReimbursement,
											{
												headers: {
													Authorization: `Bearer ${token}`,
												},
											}
										)
										.then(({ data }) => {
											setreimbursementData(data);
											AlertPopups.successAlert.fire({
												text: "Reimbursement Submitted Successfully",
											});
											history.push("/MyReimbursement");
										})
										.catch((err) => {
											if (err.response) {
												AlertPopups.ErrorAlert.fire({
													text: `${err.response.data.message}`,
												});
											}
										});
								}
							});
			}
		}
	};

	const savedRecord = () => {
		if (
			(generalOPD === null ||
				parseInt(generalOPD) === 0 ||
				generalOPD === "") &&
			(Parents === null || parseInt(Parents) === 0 || Parents === "") &&
			(Dental === null || parseInt(Dental) === 0 || Dental === "") &&
			(Maternity === null ||
				parseInt(Maternity) === 0 ||
				Maternity === "") &&
			(monthlyInternet === null ||
				parseInt(monthlyInternet) === 0 ||
				monthlyInternet === "") &&
			(others === null || parseInt(others) === 0 || others === "") &&
			(fuel === null || parseInt(fuel) === 0 || fuel === "") &&
			(mobile === null || parseInt(mobile) === 0 || mobile === "") &&
			(healthClub === null ||
				parseInt(healthClub) === 0 ||
				healthClub === "") &&
			(detail === null || detail === "")
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Enter Form Values",
			});
		} else {
			const updateReimbursement = {
				goPatientAmt:
					generalOPD.length === 0 ? 0 : parseInt(generalOPD),
				parentAmt: Parents.length === 0 ? 0 : parseInt(Parents),
				dentistAmt: Dental.length === 0 ? 0 : parseInt(Dental),
				maternityAmt: Maternity.length === 0 ? 0 : parseInt(Maternity),
				internetMonthly:
					monthlyInternet.length === 0
						? 0
						: parseInt(monthlyInternet),
				internetOther: others.length === 0 ? 0 : parseInt(others),
				carFuel: fuel.length === 0 ? 0 : parseInt(fuel),
				mobileBill: mobile.length === 0 ? 0 : parseInt(mobile),
				healthClubBill:
					healthClub.length === 0 ? 0 : parseInt(healthClub),
				submissionStatus: submissionStatus,
				details: detail,
				month: selectedMonth.value,
				year: selectedYear.value,
			};

			if (ticketNumber === 0)
				axios
					.post(
						`${MonthlyReimbursementFormAPIs.CreateMonthlyReimbursement}`,
						updateReimbursement,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data }) => {
						setTicketNumber(data.ticketNumber);
						setreimbursementData(data);
						AlertPopups.successAlert.fire({
							text: "Record Saved",
						});
						history.push("/MyReimbursement");
					})
					.catch((err) => {
						if (err.response) {
							AlertPopups.ErrorAlert.fire({
								text: "Reimbursement Already Submitted",
							});
						}
					});
			else {
				axios
					.put(
						`${ReimbursementAPIs.GetMonthlyReimbursement}/${ticketNumber}`,
						updateReimbursement,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data }) => {
						setreimbursementData(data);
						AlertPopups.successAlert.fire({
							text: "Update Successfully",
						});
						history.push("/MyReimbursement");
					})
					.catch((err) => {
						if (err.response) {
							AlertPopups.ErrorAlert.fire({
								text: "Reimbursement Already Submitted",
							});
						}
					});
			}
		}
	};
	let empDepartment = null;
	//APIs Integration for Finance
	const changeMonthlyReimbursementStatus = (value) => {
		setSubmissionStatus(value);
		let body = {
			submissionStatus: value,
		};
		axios
			.patch(
				`${ReimbursementAPIs.ChangeMonthlyReimbursementStatus}/${ticketNumber}/ChangeStatus`,
				body,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data }) => {
				const updateReimbursement = {
					goPatientAmt:
						generalOPD.length === 0 ? 0 : parseInt(generalOPD),
					parentAmt: Parents.length === 0 ? 0 : parseInt(Parents),
					dentistAmt: Dental.length === 0 ? 0 : parseInt(Dental),
					maternityAmt:
						Maternity.length === 0 ? 0 : parseInt(Maternity),
					internetMonthly:
						monthlyInternet.length === 0
							? 0
							: parseInt(monthlyInternet),
					internetOther: others.length === 0 ? 0 : parseInt(others),
					carFuel: fuel.length === 0 ? 0 : parseInt(fuel),
					mobileBill: mobile.length === 0 ? 0 : parseInt(mobile),
					healthClubBill:
						healthClub.length === 0 ? 0 : parseInt(healthClub),
					submissionStatus: value,
					details: detail,
					accountsRemarks: accountsRemarks,
				};
				id != 0 &&
					axios
						.put(
							`${ReimbursementAPIs.GetMonthlyReimbursement}/${ticketNumber}`,
							updateReimbursement,
							{ headers: { Authorization: `Bearer ${token}` } }
						)
						.then(({ data }) => {
							if (id != 0 && id) {
								axios
									.get(
										`${ReimbursementAPIs.GetSingleReimbursement}?Id=${ticketNumber}`,
										{
											headers: {
												Authorization: `Bearer ${token}`,
											},
										}
									)
									.then(({ data }) => {
										setreimbursementData({
											generalOPD: data.claimedOPD,
											Parents: data.claimedParents,
											Dental: data.claimedDental,
											Maternity: data.claimedMaternity,
											monthlyInternet:
												data.internetMonthly,
											healthClub: data.healthClubBill,
											others: data.internetOther,
											fuel: data.carFuelMaintenance,
											mobile: data.mobileBill,
											detail: data.details,
											currMonthBill: data.thisMonth,
											previousMonth: data.previousMonth,
											status: data.submissionStatus,
											accountsRemarks:
												data.accountsRemarks,
											employeeCode: data.employeeCode,
											employeeName: data.employeeName,
										});
										setFormStatus({
											status: data.submissionStatus,
											employeeId: data.employeeId,
										});
									});
							}
							AlertPopups.successAlert.fire({
								text: "Update Successfully",
							});
							history.push("/MyReimbursement");
						})
						.catch((err) => {
							if (err.response) {
								AlertPopups.ErrorAlert.fire({
									text: "Reimbursement Already Submitted",
								});
							}
						});
			});
	};

	//GET limit validation
	const checkRemainingLimit = () => {
		axios
			.get(
				`${MonthlyReimbursementFormAPIs.GetRemainingLimit}?Month=9&EmployeeId=366`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data }) => {
				setLimitValidation({
					medical: data.medical,
					internet: data.internet,
					fuel: data.fuel,
					healthClub: data.healthClub,
				});
			});
	};
	const byMonthHandler = (obj) => {
		let SelectedYear = selectedYear.value;
		let selectedMonth = obj.value;
		let currentYear = moment(new Date()).format("YYYY");

		if (SelectedYear == currentYear) {
			let currMonth = moment(new Date()).format("M");
			if (selectedMonth > currMonth) {
				let previousYear = date.getFullYear() - 1;
				SelectedYear = previousYear;
				setSelectedYear({
					value: previousYear,
					label: previousYear.toString(),
				});
				setCurrentYear(previousYear);
			}
		}
		setSelectedMonth(obj);
		setCurrentMonth(obj.label);
		callMonthlyReimbursement(selectedMonth, SelectedYear);
	};
	const byYearHandler = (obj) => {
		let SelectedMonth = selectedMonth.value;
		let SelectedYear = obj.value;
		let currentYear = moment(new Date()).format("YYYY");
		if (SelectedYear == currentYear) {
			let currMonth = moment(new Date()).format("M");
			if (SelectedMonth > currMonth) {
				SelectedMonth = date.getMonth() + 1;
				setSelectedMonth(monthsList[date.getMonth()]);
				setCurrentMonth(monthsList[date.getMonth()].label);
			}
		}

		setSelectedYear(obj);
		setCurrentYear(obj.value);
		callMonthlyReimbursement(SelectedMonth, obj.value);
	};
	const callMonthlyReimbursement = (month, year) => {
		if (empDepartment === "5") {
			axios
				.get(
					`${ReimbursementAPIs.GetSingleReimbursement}?EmployeeId=${formStatus.employeeId}&Month=${month}&Year=${year}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then(({ data }) => {
					setreimbursementData({
						generalOPD: data.claimedOPD,
						Parents: data.claimedParents,
						Dental: data.claimedDental,
						Maternity: data.claimedMaternity,
						monthlyInternet: data.internetMonthly,
						healthClub: data.healthClubBill,
						others: data.internetOther,
						fuel: data.carFuelMaintenance,
						mobile: data.mobileBill,
						detail: data.details,
						currMonthBill: data.thisMonth,
						previousMonth: data.previousMonth,
						status: data.submissionStatus,
						employeeCode: data.employeeCode,
						employeeName: data.employeeName,
					});
					setFormStatus({
						status: data.submissionStatus,
						employeeId: data.employeeId,
					});
					setTicketNumber(data.appID);
				});
		} else
			axios
				.get(
					`${ReimbursementAPIs.GetSingleReimbursement}?Month=${month}&Year=${year}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then(({ data }) => {
					setreimbursementData({
						generalOPD: data.claimedOPD,
						Parents: data.claimedParents,
						Dental: data.claimedDental,
						Maternity: data.claimedMaternity,
						monthlyInternet: data.internetMonthly,
						healthClub: data.healthClubBill,
						others: data.internetOther,
						fuel: data.carFuelMaintenance,
						mobile: data.mobileBill,
						detail: data.details,
						currMonthBill: data.thisMonth,
						previousMonth: data.previousMonth,
						status: data.submissionStatus,
						employeeCode: data.employeeCode,
						employeeName: data.employeeName,
					});
					setFormStatus({
						status: data.submissionStatus,
						employeeId: data.employeeId,
					});
					setTicketNumber(data.appID);
				});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDepartment = userDetails.department;
				return (
					<Container fluid className="p-0">
						<Row>
							<Col className="pr-0" sm={recordID ? 5 : 4}>
								<FormStatus
									title={
										recordID
											? `Reimbursement Month : ${currentMonth} ${currentYear}`
											: null
									}
									className="reimbursemnet-create-req-title mt-3"
									onClick={() => {
										history.push({
											pathname: "/MyReimbursement",
											state: {
												employeeId:
													formStatus.employeeId,
												selectedMonth: currentMonth,
												selectedYear: selectedYear,
												status: status,
											},
										});
									}}
									formStatus={formStatus.status}
									navigateBack={true}
								/>
							</Col>
							<Col className="pl-0">
								<div
									className="reimbursemnet-create-req-title"
									style={{ marginTop: "12px" }}
								>
									<label className="mb-0">Month</label>
									<Col sm={3} className="mr-2">
										<CustomReactSelect
											options={monthsList}
											onChange={(obj) =>
												byMonthHandler(obj)
											}
											value={selectedMonth}
											paginationDropDown={true}
										/>
									</Col>
									<label className="mb-0">Year</label>
									<Col sm={3}>
										<CustomReactSelect
											options={yearsList}
											onChange={(obj) =>
												byYearHandler(obj)
											}
											value={selectedYear}
											paginationDropDown={true}
										/>
									</Col>
								</div>
							</Col>
						</Row>
						<Row className="mt-4 row-cols-2 sub-header">
							<Col
								lg={10}
								className="d-flex align-items-center emp-information"
							>
								<Col lg={10} className="reimbursement-month">
									Employee:
									<span className="emp-code">
										{" "}
										{reimbursementData.employeeName} (
										{reimbursementData.employeeCode})
									</span>{" "}
								</Col>
							</Col>
							<Col
								lg={2}
								className="d-flex"
								style={{ justifyContent: "flex-end" }}
							>
								<Link
									to={{
										pathname: "/Calculator",
										state: {
											employeeId: formStatus.employeeId,
											recordID: recordID,
										},
									}}
								>
									<Button>Calculate</Button>
								</Link>
							</Col>
						</Row>
						<Form className="mt-4 reimbursement-form">
							<Label
								className="reimbursement-form-title d-flex"
								sm={12}
							>
								<div>Reimbursement form</div>
								{ticketNumber > 0 && (
									<div className="mr-4">
										Ticket# {ticketNumber}
									</div>
								)}
							</Label>
							<Form.Group className="mb-0">
								<Row className="align-items-center medical-reimburse">
									<Col
										lg={2}
										className="reimburse-form-label"
									>
										Medical
									</Col>
									<Col>
										<div className="did-floating-label-content">
											<input
												className="did-floating-input"
												type="number"
												name="generalOPD"
												onChange={handleChange}
												value={
													reimbursementData.generalOPD
												}
												disabled={
													empDepartment === "5"
														? false
														: reimbursementData.status ===
																"Pending" ||
														  reimbursementData.status ===
																"Paid" ||
														  reimbursementData.status ===
																"Approved"
														? true
														: false
												}
												onInput={(e) => {
													e.target.value = Math.max(
														0,
														parseInt(e.target.value)
													)
														.toString()
														.slice(0, 6);
												}}
											/>
											<label
												className="did-floating-label"
												style={
													reimbursementData.generalOPD
														? { top: "-8px" }
														: null
												}
											>
												General OPD
											</label>
										</div>
										<Button
											disabled={true}
											className="toggle-btn1"
										>
											{limitCalculation(
												generalOPD
											)?.toLocaleString()}
										</Button>
									</Col>
									<Col>
										<div className="did-floating-label-content">
											<input
												className="did-floating-input"
												type="number"
												name="Parents"
												onChange={handleChange}
												value={
													reimbursementData.Parents
												}
												disabled={
													empDepartment === "5"
														? false
														: reimbursementData.status ===
																"Pending" ||
														  reimbursementData.status ===
																"Paid" ||
														  reimbursementData.status ===
																"Approved"
														? true
														: false
												}
												onInput={(e) => {
													e.target.value = Math.max(
														0,
														parseInt(e.target.value)
													)
														.toString()
														.slice(0, 6);
												}}
											/>
											<label
												className="did-floating-label"
												style={
													reimbursementData.Parents
														? { top: "-8px" }
														: null
												}
											>
												Parents
											</label>
										</div>
										<Button
											disabled={true}
											className="toggle-btn2"
										>
											{limitCalculation(
												Parents
											)?.toLocaleString()}
										</Button>
									</Col>
									<Col>
										<div className="did-floating-label-content">
											<input
												className="did-floating-input"
												type="number"
												name="Dental"
												onChange={handleChange}
												value={reimbursementData.Dental}
												disabled={
													empDepartment === "5"
														? false
														: reimbursementData.status ===
																"Pending" ||
														  reimbursementData.status ===
																"Paid" ||
														  reimbursementData.status ===
																"Approved"
														? true
														: false
												}
												onInput={(e) => {
													e.target.value = Math.max(
														0,
														parseInt(e.target.value)
													)
														.toString()
														.slice(0, 6);
												}}
											/>
											<label
												className="did-floating-label"
												style={
													reimbursementData.Dental
														? { top: "-8px" }
														: null
												}
											>
												Dental
											</label>
										</div>
										<Button
											disabled={true}
											className="toggle-btn3"
										>
											{limitCalculation(
												Dental
											)?.toLocaleString()}
										</Button>
									</Col>
									<Col>
										<div className="did-floating-label-content">
											<input
												className="did-floating-input"
												type="number"
												name="Maternity"
												onChange={handleChange}
												value={
													reimbursementData.Maternity
												}
												disabled={
													empDepartment === "5"
														? false
														: reimbursementData.status ===
																"Pending" ||
														  reimbursementData.status ===
																"Paid" ||
														  reimbursementData.status ===
																"Approved"
														? true
														: false
												}
												onInput={(e) => {
													e.target.value = Math.max(
														0,
														parseInt(e.target.value)
													)
														.toString()
														.slice(0, 6);
												}}
											/>
											<label
												className="did-floating-label"
												style={
													reimbursementData.Maternity
														? { top: "-8px" }
														: null
												}
											>
												Maternity
											</label>
										</div>
										<Button
											disabled={true}
											className="toggle-btn4"
										>
											{limitCalculation(
												Maternity
											)?.toLocaleString()}
										</Button>
									</Col>
								</Row>
							</Form.Group>
							<Form.Group className="mb-0">
								<Row className="align-items-center internet-reimburse">
									<Col
										lg={2}
										className="reimburse-form-label"
									>
										Home Internet
									</Col>
									<Col>
										<div className="did-floating-label-content">
											<input
												className="did-floating-input"
												type="number"
												name="monthlyInternet"
												onChange={handleChange}
												value={
													reimbursementData.monthlyInternet
												}
												disabled={
													empDepartment === "5"
														? false
														: reimbursementData.status ===
																"Pending" ||
														  reimbursementData.status ===
																"Paid" ||
														  reimbursementData.status ===
																"Approved"
														? true
														: false
												}
												onInput={(e) => {
													e.target.value = Math.max(
														0,
														parseInt(e.target.value)
													)
														.toString()
														.slice(0, 6);
												}}
											/>
											<label
												className="did-floating-label"
												style={
													reimbursementData.monthlyInternet
														? { top: "-8px" }
														: null
												}
											>
												Home Internet
											</label>
										</div>
									</Col>
									<Col>
										<div className="did-floating-label-content">
											<input
												className="did-floating-input"
												type="number"
												name="others"
												onChange={handleChange}
												value={reimbursementData.others}
												disabled={
													empDepartment === "5"
														? false
														: reimbursementData.status ===
																"Pending" ||
														  reimbursementData.status ===
																"Paid" ||
														  reimbursementData.status ===
																"Approved"
														? true
														: false
												}
												onInput={(e) => {
													e.target.value = Math.max(
														0,
														parseInt(e.target.value)
													)
														.toString()
														.slice(0, 6);
												}}
											/>
											<label
												className="did-floating-label"
												style={
													reimbursementData.others
														? { top: "-8px" }
														: null
												}
											>
												Others
											</label>
										</div>
									</Col>
								</Row>
							</Form.Group>
							
							{selectedYear.value <= 2023 ? (
  <>
							<Form.Group className="mb-0">
								<Row className="align-items-center health-club">
									<Col
										lg={2}
										className="reimburse-form-label"
									>
										Health Club
									</Col>
									<Col>
										<div className="did-floating-label-content">
											<input
												className="did-floating-input"
												type="number"
												name="healthClub"
												onChange={handleChange}
												value={
													reimbursementData.healthClub
												}
												disabled={
													empDepartment === "5"
														? false
														: reimbursementData.status ===
																"Pending" ||
														  reimbursementData.status ===
																"Paid" ||
														  reimbursementData.status ===
																"Approved"
														? true
														: false
												}
												onInput={(e) => {
													e.target.value = Math.max(
														0,
														parseInt(e.target.value)
													)
														.toString()
														.slice(0, 6);
												}}
											/>
											<label
												className="did-floating-label"
												style={
													reimbursementData.healthClub
														? { top: "-8px" }
														: null
												}
											>
												Health Club
											</label>
										</div>
									</Col>
								</Row>
							</Form.Group>
							</>
     ) : null}
							<Form.Group className="mb-0">
								<Row className="align-items-center fuel-reimburse">
									<Col
										lg={2}
										className="reimburse-form-label"
									>
										Fuel/Mobile
									</Col>
									<Col>
										<div className="did-floating-label-content">
											<input
												className="did-floating-input"
												type="number"
												name="fuel"
												onChange={handleChange}
												value={reimbursementData.fuel}
												disabled={
													empDepartment === "5"
														? false
														: reimbursementData.status ===
																"Pending" ||
														  reimbursementData.status ===
																"Paid" ||
														  reimbursementData.status ===
																"Approved"
														? true
														: false
												}
												onInput={(e) => {
													e.target.value = Math.max(
														0,
														parseInt(e.target.value)
													)
														.toString()
														.slice(0, 6);
												}}
											/>
											<label
												className="did-floating-label"
												style={
													reimbursementData.fuel
														? { top: "-8px" }
														: null
												}
											>
												Fuel
											</label>
										</div>
									</Col>
									<Col>
										<div className="did-floating-label-content">
											<input
												className="did-floating-input"
												type="number"
												name="mobile"
												onChange={handleChange}
												value={reimbursementData.mobile}
												disabled={
													empDepartment === "5"
														? false
														: reimbursementData.status ===
																"Pending" ||
														  reimbursementData.status ===
																"Paid" ||
														  reimbursementData.status ===
																"Approved"
														? true
														: false
												}
												onInput={(e) => {
													e.target.value = Math.max(
														0,
														parseInt(e.target.value)
													)
														.toString()
														.slice(0, 6);
												}}
											/>
											<label
												className="did-floating-label"
												style={
													reimbursementData.mobile
														? { top: "-8px" }
														: null
												}
											>
												Mobile
											</label>
										</div>
									</Col>
								</Row>
							</Form.Group>

							<Form.Group className="mb-0">
								<Row className="align-items-center submission">
									<Col
										lg={2}
										className="reimburse-form-label"
									>
										Submission
									</Col>
									<Col>
										<Form.Control
											as="textarea"
											rows={3}
											name="detail"
											value={
												reimbursementData.detail ===
												null
													? ""
													: reimbursementData.detail
											}
											className="input"
											onChange={handleChange}
											readOnly={
												empDepartment === "5"
													? false
													: reimbursementData.status ===
															"Pending" ||
													  reimbursementData.status ===
															"Paid"
													? true
													: false
											}
											maxLength={1000}
										/>
									</Col>
								</Row>
							</Form.Group>
							{reimbursementData.status === "Rejected" &&
								empDepartment === "5" && (
									<Form.Group className="mb-0">
										<Row className="align-items-center internet-reimburse">
											<Col
												lg={2}
												className="reimburse-form-label"
											>
												Rejection Purpose
											</Col>
											<Col>
												<Form.Control
													name="accountsRemarks"
													as="textarea"
													className="input"
													rows={3}
													value={accountsRemarks}
													onChange={handleChange}
													readOnly={
														reimbursementData.status ===
														"Paid"
															? true
															: false
													}
													maxLength={500}
												/>
											</Col>
										</Row>
									</Form.Group>
								)}

							{empDepartment != "5" &&
								reimbursementData.status === "Rejected" && (
									<Form.Group className="mb-0">
										<Row className="align-items-center internet-reimburse">
											<Col
												lg={2}
												className="reimburse-form-label"
											>
												Rejection Purpose
											</Col>
											<Col>
												<Form.Control
													name="accountsRemarks"
													as="textarea"
													className="input"
													rows={3}
													value={accountsRemarks}
													onChange={handleChange}
													readOnly={
														reimbursementStatus !=
															"Paid" &&
														empDepartment != "5"
															? true
															: false
													}
												/>
											</Col>
										</Row>
									</Form.Group>
								)}
						</Form>
						<Col
							md={12}
							className="d-flex mt-3 remaining-limit px-0"
							style={{ justifyContent: "space-between" }}
						>
							<div sm={12}>
								<span style={{ fontWeight: "normal" }}>
									Previous Months Bill:{" "}
								</span>
								<span className="reimbRemainingLimit">
									{reimbursementData?.previousMonth?.toLocaleString()}
								</span>
							</div>
							<div>
								<span style={{ fontWeight: "normal" }}>
									Current Month Bill:{" "}
								</span>
								<span className="reimbRemainingLimit">
									{reimbursementData?.currMonthBill?.toLocaleString()}
								</span>
							</div>
						</Col>
						<Row
							className="mt-3 mr-1"
							style={{ justifyContent: "flex-end" }}
						>
							{formStatus.status === "Draft" ||
							formStatus.status === "Rejected" ? (
								<div className="btns">
									<Button
										className="submit-btn leftBtn"
										onClick={handleSubmit}
									>
										Submit
									</Button>
									<Button
										className="reset-btn"
										onClick={savedRecord}
									>
										Save
									</Button>
								</div>
							) : null}
							{empDepartment === "5" &&
								formStatus.status != "Draft" && (
									<div className="finance-department-btns">
										<Button
											className="approved-btn"
											onClick={() =>
												changeMonthlyReimbursementStatus(
													5
												)
											}
										>
											Set as Processing
										</Button>
										<Button
											className="approved-btn"
											onClick={() =>
												changeMonthlyReimbursementStatus(
													2
												)
											}
										>
											Set as Approved
										</Button>
										<Button
											className="reject-btn"
											onClick={() =>
												changeMonthlyReimbursementStatus(
													3
												)
											}
										>
											Set as Rejected
										</Button>
										<Button
											className="paid-btn"
											onClick={() =>
												changeMonthlyReimbursementStatus(
													4
												)
											}
										>
											Set as Paid
										</Button>
										<Button
											className="gReimbursementPending-btn"
											onClick={() =>
												changeMonthlyReimbursementStatus(
													1
												)
											}
										>
											Set as Pending
										</Button>
									</div>
								)}
						</Row>
					</Container>
				);
			}}
		</UserConsumer>
	);
};

export default MonthlyReimbursementForm;
